import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
// import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
// import CustomLogInModal from './components/CustomLogInModal';
import LogInModal from 'flarum/forum/components/LogInModal';
import Button from 'flarum/common/components/Button';



app.initializers.add('dvdfab/custom-login', () => {
  override(LogInModal.prototype, 'onsubmit', function(original, e) {
    e.preventDefault();
    this.loading = true;
    // 使用自定义的登录接口
    const loginData = {
      identification: this.identification() ? this.identification().trim() : '',
      password: this.password() ? this.password().trim() : '',
      remember: this.remember(),
    };

    app.request({
      method: 'POST',
      url: `${app.forum.attribute('baseUrl')}/api/custom-login`,
      body: loginData,
      errorHandler: this.onerror.bind(this)
    }).then((response) => {
      // 登录成功后的处理
      if (response && response.token) {
        // 设置用户会话
        app.session.user = response.user;
        app.session.csrfToken = response.csrfToken;
        
        // 关闭模态框
        app.modal.close();
        
        // 刷新页面或重定向
        window.location.reload();
      } else {
        this.loaded();
        this.alertAttrs = {
          type: 'error',
          content: app.translator.trans('core.forum.log_in.invalid_login_message')
        };
        m.redraw();
      }
    }).catch((error) => {
      this.loaded();
      this.onerror(error);
    });
  });
  override(LogInModal.prototype, 'onerror', function(error) {
     if (error.status === 401 || error.status === 422) {
      this.alertAttrs = {
        type: 'error',
        content: app.translator.trans('core.forum.log_in.invalid_login_message')
      };
      this.password('');
    } else {
      this.alertAttrs = {
        type: 'error',
        content: error.responseText || 'login fail'
      };
    }

    this.loading = false;
    m.redraw();
  });

  extend(LogInModal.prototype, 'fields', function(items) {

  const mainDomains = app.forum.attribute('dvdfabDomains');
  const currentLocale = app.data.locale;
  // loginButton.attrs.onclick = () => app.modal.show(CustomLogInModal);
  // loginButton.attrs.onclick = () => window.location.href = `https://${mainDomains[currentLocale]}/member.htm?a=login&redirect=${encodeURIComponent(window.location.href)}`;
  const loginUrl = `${mainDomains[currentLocale]}/member.htm?a=login&redirect=${encodeURIComponent(window.location.href)}`;
  //loginButton.attrs.onclick = () => window.location.href = `http://localhost:3000/member.htm?a=login&redirect=${encodeURIComponent(window.location.href)}`;
   items.add(
      'dvdfabMember',
      <div className="Form-group">
        <Button 
          className="Button Button--primary Button--block" 
          onclick={() => window.location.href = loginUrl} 
        >
          {app.translator.trans('dvdfab-custom-login.forum.dvdfab_member_login')}
        </Button>
      </div>,
      -20
    );
    
    return items;
  });

  override(LogInModal.prototype, 'forgotPassword', function() {
    const email = this.identification();
    const attrs = email.includes('@') ? { email } : undefined;

    // app.modal.show(ForgotPasswordModal, attrs);
    const currentLocale = app.data.locale;
    const mainDomains = app.forum.attribute('dvdfabDomains');
    // loginButton.attrs.onclick = () => window.location.href = `https://${mainDomains[currentLocale]}/member.htm?a=login&redirect=${encodeURIComponent(window.location.href)}`;
    window.location.href = `${mainDomains[currentLocale]}/member.htm?a=ForgetPassword&t=per`;
    // loginButton.attrs.onclick = () => window.location.href = `http://localhost:3000/member.htm?a=login&redirect=${encodeURIComponent(window.location.href)}`;
  });


  // extend(HeaderSecondary.prototype, 'items', function(items) {
  //   if (items.has('logIn')) {
  //     const loginButton = items.get('logIn');
  //     if (loginButton && loginButton.attrs) {
  //       const currentLocale = app.data.locale;
  //         loginButton.attrs.onclick = () => app.modal.show(CustomLogInModal);
  //         // loginButton.attrs.onclick = () => window.location.href = `https://${mainDomains[currentLocale]}/member.htm?a=login&redirect=${encodeURIComponent(window.location.href)}`;
  //         // loginButton.attrs.onclick = () => window.location.href = `https://test12.dvdfab.cn/member.htm?a=login&redirect=${encodeURIComponent(window.location.href)}`;
  //         // loginButton.attrs.onclick = () => window.location.href = `http://localhost:3000/member.htm?a=login&redirect=${encodeURIComponent(window.location.href)}`;
  //     }
  //   }
  // });
});